import script from "./ow-appointment-calendar.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-appointment-calendar.vue?vue&type=script&setup=true&lang=js"

import "./ow-appointment-calendar.vue?vue&type=style&index=0&id=fdc042de&lang=scss"

const __exports__ = script;

export default __exports__